<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="90px">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="queryParams.name" placeholder="请输入姓名" clearable @keyup.enter.native="handleQuery" />
      </el-form-item>

      <el-form-item label="联系人电话" prop="phone">
        <el-input
          v-model="queryParams.phone"
          placeholder="请输入联系人电话"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="是否绑定" prop="type">
        <el-radio-group v-model="queryParams.type">
          <el-radio :label="0" border style="margin-right: 5px">全部</el-radio>
          <el-radio :label="2" border style="margin-right: 5px">已绑定</el-radio>
          <el-radio :label="1" border style="margin-right: 5px">未绑定</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="打卡时间">
        <el-date-picker
          v-model="queryParams.time"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="请选择打卡时间"
        ></el-date-picker>
      </el-form-item> -->
      <!-- <el-form-item label="打卡时间">
        <el-date-picker
          v-model="dateRangeList"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item> -->
      <!-- <el-form-item label="打卡时间" prop="time">
        <el-input
          v-model="queryParams.time"
          placeholder="请输入联系人电话"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <!-- <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['system:company:add']"
        >新增</el-button>
      </el-col> -->
      <!-- <el-col :span="1.5" v-if="dateRangeList != null">
        <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col> -->
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="companyList" height="550">
      <!-- <el-table-column type="selection" width="55" align="center" /> -->
      <!-- <el-table-column label="id" align="center" prop="id" /> -->
      <el-table-column label="照片" align="center" prop="image" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <image-preview :src="row.image" :width="45" :height="45" />
        </template>
      </el-table-column>
      <el-table-column label="所属部门" align="center" prop="dptmntName" />
      <el-table-column label="姓名" align="center" prop="name" />
      <el-table-column label="是否绑定" align="center" prop="image">
        <template slot-scope="{ row }">
          <el-tag size="small" v-if="row.image != null" type="success">已绑定</el-tag>
          <el-tag size="small" v-else type="danger">未绑定</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="电话" align="center" prop="phone" />
      <el-table-column label="绑定时间" align="center" prop="updateTime" />
      <!-- <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button icon="el-icon-search" circle size="mini" @click="handleEdits(scope.row)"></el-button>

          <el-button size="mini" type="danger" class="el-icon-delete" @click="handleDelete(scope.row)"></el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <pagination
      v-show="total > 0"
      :total="Number(total)"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!--新增编辑界面-->
    <el-drawer
      :title="title"
      :visible.sync="open"
      :before-close="handleClose"
      destroy-on-close
      class="headerts editdrawer"
      size="30%"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        style="padding-right: 30px"
        :disabled="title == '查看公司'"
      >
        <el-col :span="24">
          <el-form-item label="公司名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入公司名称" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="联系人姓名" prop="contactName">
            <el-input v-model="form.contactName" placeholder="请输入联系人姓名" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="联系人电话" prop="contactPhone">
            <el-input v-model="form.contactPhone" placeholder="请输入联系人电话" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="公司地址" prop="address">
            <el-input v-model="form.address" placeholder="请输入公司地址" />
          </el-form-item>
        </el-col>
      </el-form>
      <div class="dialog-footer" v-if="title !== '查看公司'">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { sysUserPage } from '@/api/clockIn'

export default {
  name: 'Company',
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 公司表格数据
      companyList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: null,
        type: 0,
        platformId: this.$route.query.platformId,
        companyId: this.$route.query.EId
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        name: [
          {
            required: true,
            message: '请选择输入正确公司名称',
            trigger: 'blur',
          },
        ],
        contactName: [
          {
            required: true,
            message: '请选择输入正确联系人姓名',
            trigger: 'blur',
          },
        ],
        contactPhone: [
          {
            required: true,
            message: '请选择输入正确联系人电话',
            trigger: 'blur',
          },
        ],
        address: [{ required: true, message: '请输入正确公司地址', trigger: 'blur' }],
      },
      // 日期范围
      dateRangeList: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    /** 查询打卡时间 */
    getList() {
      this.loading = true

      sysUserPage(this.queryParams).then((response) => {
        if (response.code == 200) {
          this.companyList = response.data.list
          this.total = response.data.total
          this.loading = false
        }
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        name: null,
        contactName: null,
        contactPhone: null,
        address: null,
        createTime: null,
      }
      this.resetForm('form')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      console.log(this.dateRangeList)
      if (this.dateRangeList != null) {
        if (this.dateRangeList.length != 0) {
          this.queryParams.firstDay = this.dateRangeList[0]
          this.queryParams.lastDay = this.dateRangeList[1]
        } else {
          this.queryParams.firstDay = undefined
          this.queryParams.lastDay = undefined
        }
      } else {
        this.queryParams.firstDay = undefined
        this.queryParams.lastDay = undefined
      }
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },

    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.title = '添加公司'
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      const id = row.id || this.ids
      getCompany(id).then((response) => {
        this.form = response.data
        this.open = true
        this.title = '修改公司'
      })
    },
    /** 查看按钮操作 */
    handleEdits(row) {
      this.reset()
      const id = row.id || this.ids
      getCompany(id).then((response) => {
        this.form = response.data
        this.open = true
        this.title = '查看公司'
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateCompany(this.form).then((response) => {
              this.$modal.msgSuccess('修改成功')
              this.open = false
              this.getList()
            })
          } else {
            addCompany(this.form).then((response) => {
              this.$modal.msgSuccess('新增成功')
              this.open = false
              this.getList()
            })
          }
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids
      this.$modal
        .confirm('是否确认删除公司编号为"' + ids + '"的数据项？')
        .then(function () {
          return delCompany(ids)
        })
        .then(() => {
          this.getList()
          this.$modal.msgSuccess('删除成功')
        })
        .catch(() => {})
    },
    /** 导出按钮操作 */
    handleExport() {
      if (this.dateRangeList.length != 0) {
        // this.queryParams.firstDay = this.dateRange[0]
        // this.queryParams.lastDay = this.dateRange[1]
        var firstDay = this.dateRangeList[0]
        var lastDay = this.dateRangeList[1]
      } else {
        // this.queryParams.firstDay = undefined
        // this.queryParams.lastDay = undefined
        var firstDay = undefined
        var lastDay = undefined
      }
      var params = {
        firstDay: firstDay,
        lastDay: lastDay,
      }
      this.download(
        'OA/unlockRecord/export',
        {
          ...params,
        },
        `考勤记录_${new Date().getTime()}.xlsx`
      )
    },
    // 弹框退出事件
    handleClose() {
      this.open = false
    },
  },
}
</script>

<style>
.dialog-footer {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
}
</style>
